import React, { useEffect, useMemo } from "react";
import { Form, Button, Offcanvas } from "react-bootstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  setPaginationPageNumber,
  setActiveTab,
  TriggerFilterButtonApi,
} from "../../../slices/common/reducer";
import { setQuoteFilterForm } from "../../../slices/orders/orderSlice";
import { setProductData } from "../../../slices/product/productSlice";
import { setAffinityGroupData } from "../../../slices/ag/affinityGroup/affinityGroupSlice";
import { getFilteredDataWithTabs } from "../../../Utils/CommonService";
import "../Orders/Order.scss";

const QuoteAdvancedFilter = ({ show, onClose }) => {
  const dispatch = useDispatch();
  const filterForm = useSelector((state) => state.order.quoteFilter.form);
  const filterApi = useSelector((state) => state.order.quoteFilter.filterApi);
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const productData = useSelector((state) => state.product.productData);
  const affinityGroupData = useSelector(
    (state) => state.affinityGroup.affinityGroupData
  );
  const organizationId = selectedUser.organizationid;
  const enterpriseid = localStorage.getItem("enterpriseid");
  const userid = localStorage.getItem("userId");

  const resetTabAndPageNumber = () => {
    dispatch(setPaginationPageNumber(0));
    dispatch(setActiveTab("ALL"));
  };

  const handleApply = () => {
    dispatch(TriggerFilterButtonApi());
    onClose();
  };

  const handleClear = () => {
    dispatch(setQuoteFilterForm({ type: "reset" }));

    if (!filterApi) return;

    dispatch(TriggerFilterButtonApi());

    if (Object.keys(filterForm).length > 0) {
      resetTabAndPageNumber();
    }
  };

  const productOptions = productData.map((item) => ({
    value: item.name,
    label: item.name,
  }));

  const agOptions = affinityGroupData.map((item) => ({
    value: item.name,
    label: item.name,
  }));

  const listParams = useMemo(
    () => ({
      page: 0,
      size: 50,
      sort_column: "created_date",
      sort_order: "ASC",
      listEntityType: "AGRP",
    }),
    []
  );

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        await getFilteredDataWithTabs(
          "PPET",
          setProductData,
          {},
          listParams,
          "ALL",
          null,
          organizationId,
          null,
          enterpriseid,
          null,
          null,
          null,
          null,
          null,
          null
        );
        // getFilteredDataWithTabs is debounced, so the calls must be spaced out
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await getFilteredDataWithTabs(
          "AGRP",
          setAffinityGroupData,
          {},
          listParams,
          "ALL",
          null,
          null,
          null,
          enterpriseid,
          userid,
          "AG",
          null,
          null,
          null,
          null,
          null
        );
      } catch (error) {
        console.error("Error fetching quote filter data:", error);
      }
    };

    if (show) {
      fetchDropdownData();
    }
  }, [show, organizationId, enterpriseid, listParams]);

  return (
    <Offcanvas show={show} onHide={onClose} placement="end">
      <div className="advance-filter-container">
        <Offcanvas.Header className="offcanvas--header" closeButton>
          <Offcanvas.Title>Quote Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form className="offcanvas-container">
            <Form.Group className="form-css">
              <Form.Label>Product</Form.Label>
              <Select
                isClearable
                placeholder="Product"
                name="name"
                options={productOptions}
                value={
                  productOptions.find(
                    (itm) => itm.value === filterForm?.name
                  ) || null
                }
                onChange={(e) => {
                  dispatch(
                    setQuoteFilterForm({
                      name: "name",
                      value: e?.value,
                    })
                  );
                }}
              />
            </Form.Group>
            <Form.Group className="form-css">
              <Form.Label>AG</Form.Label>
              <Select
                isClearable
                placeholder="AG"
                name="ag_name"
                options={agOptions}
                value={
                  agOptions.find((itm) => itm.value === filterForm?.ag_name) ||
                  null
                }
                onChange={(e) => {
                  dispatch(
                    setQuoteFilterForm({
                      name: "ag_name",
                      value: e?.value,
                    })
                  );
                }}
              />
            </Form.Group>
          </Form>
        </Offcanvas.Body>
        <div className="offcanvas--footer">
          <Button className="primary-outline clear" onClick={handleClear}>
            Clear
          </Button>
          <Button className="primary_button apply" onClick={handleApply}>
            Apply
          </Button>
        </div>
      </div>
    </Offcanvas>
  );
};

export default QuoteAdvancedFilter;
